import { useRef } from 'react';

import { categoriesData } from './data';
import Category from './elems/Category';
import LandingProductsSection from '@LandingComponents/LandingProductsSection';
import styles from './Categories.module.css';

import type { FC, HTMLAttributes } from 'react';
import type { CategoryData } from '../../typings';

export interface CategoriesProps extends HTMLAttributes<HTMLDivElement> {
  categories: CategoryData[];
  analyticsTitle: string;
}

const Categories: FC<CategoriesProps> = (props) => {
  const { categories, analyticsTitle, ...restProps } = props;
  const ref = useRef<HTMLDivElement>(null);

  const filteredСategories = categories
    .map((category) => {
      // Если с бэка пришла неизвестная категория - пропускаем
      if (!Object.keys(categoriesData).includes(category.name)) return;

      const newCategory = { ...category, ...categoriesData[category.name] };
      return newCategory;
    })
    .filter((category) => category);

  return (
    <div {...restProps} ref={ref}>
      {filteredСategories.map((category, index) => {
        return (
          <div className={styles.container} key={category.title}>
            <Category
              className={styles.category}
              reverse={index % 2 === 1}
              category={category}
              analyticsTitle={analyticsTitle}
            />
            <LandingProductsSection
              products={category.products}
              button={{ link: category.link }}
              analyticsTitle={analyticsTitle}
            />
          </div>
        );
      })}
    </div>
  );
};

export default Categories;
